module.exports = __webpack_public_path__ + "img/01.8bb3b4a1.png";